import { createContext, useContext, ReactNode, FC } from 'react';
import { useNavigate } from 'react-router-dom';

interface SubscriptionUpgradeContextType {
  startUpgradeFlow: () => void;
}

const SubscriptionUpgradeContext = createContext<SubscriptionUpgradeContextType | null>(null);

/**
 * Provider component that manages the subscription upgrade flow
 * Redirects to /plans page for subscription management
 */
export const SubscriptionUpgradeProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const navigate = useNavigate();

  /**
   * Start the upgrade flow
   * This can be called from any component that wants to trigger an upgrade
   * Now simply redirects to the plans page
   */
  const startUpgradeFlow = () => {
    navigate('/plans');
  };

  return (
    <SubscriptionUpgradeContext.Provider value={{ startUpgradeFlow }}>
      {children}
    </SubscriptionUpgradeContext.Provider>
  );
};

/**
 * Hook to access the subscription upgrade flow
 * Must be used within SubscriptionUpgradeProvider
 */
export const useSubscriptionUpgrade = (): SubscriptionUpgradeContextType => {
  const context = useContext(SubscriptionUpgradeContext);
  
  if (!context) {
    throw new Error('useSubscriptionUpgrade must be used within SubscriptionUpgradeProvider');
  }
  
  return context;
};

